/* eslint-disable , @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match */
export class RoutingConfig {
    public static readonly PathMatch: { readonly Full: 'full'; readonly Prefix: 'prefix' } = {
        Full: 'full', // segments of the URL match
        Prefix: 'prefix' // the remaining URL begins with the route's prefix path
    };
    public static readonly CONF01V2: { readonly Base: string; readonly Copy: string; readonly New: string; readonly View: string } = {
        Base: 'conf01',
        Copy: ':copy/:id',
        New: 'new',
        View: ':id'
    };
    public static readonly CONF01: { readonly Base: string; readonly View: string } = {
        Base: 'conf01dcs',
        View: ':id'
    };
    public static readonly PASS01 = {
        Base: 'pass01',
        View: ':id'
    };
    public static readonly SP08: { readonly Base: string; readonly New: string; readonly NewWithTap: string; readonly View: string } = {
        Base: 'sp08',
        New: 'new',
        NewWithTap: 'new/:tapCode',
        View: ':id'
    };
    public static readonly SP04: { readonly Base: string; readonly New: string; readonly NewWithSalePoint: string; readonly View: string } = {
        Base: 'sp04',
        New: 'new',
        NewWithSalePoint: `new/:salePointId`,
        View: ':id'
    };
    public static readonly API01: { readonly Base: string; readonly New: string; readonly View: string } = {
        Base: 'api01m',
        New: 'new',
        View: ':id'
    };
    public static readonly API01V2: { readonly Base: string; readonly New: string; readonly View: string } = {
        Base: 'api01',
        New: 'new',
        View: ':id'
    };
    public static readonly PS01: { readonly Base: string; readonly Copy: string; readonly New: string; readonly View: string } = {
        Base: 'ps01',
        Copy: ':copy/:id',
        New: 'new',
        View: ':id'
    };
    public static readonly PS02: { readonly Base: string; readonly New: string; readonly View: string } = {
        Base: 'ps02',
        New: 'new',
        View: ':id'
    };
    public static readonly REX01: { readonly Base: string; readonly Copy: string; readonly New: string; readonly View: string } = {
        Base: 'rex01',
        Copy: ':copy/:id',
        New: 'new',
        View: ':id'
    };
    public static readonly CSC01: { readonly Base: string; readonly Copy: string; readonly New: string; readonly View: string } = {
        Base: 'csc01',
        Copy: ':copy/:id',
        New: 'new',
        View: ':id'
    };
    public static readonly CSC03: { readonly Base: string; readonly New: string; readonly View: string } = {
        Base: 'csc03',
        New: 'new',
        View: ':id'
    };
    public static readonly GDS01: { readonly Base: string; readonly Copy: string; readonly New: string; readonly View: string } = {
        Base: 'gds01',
        Copy: ':copy/:id',
        New: 'new',
        View: ':id'
    };
    public static readonly CCR01: { readonly Complete: string; readonly Base: string; readonly New: string; readonly View: string } = {
        Base: 'ccr01',
        Complete: 'complete',
        New: 'new',
        View: ':id'
    };
    public static readonly AA02: { readonly Base: string; readonly New: string; readonly View: string } = {
        Base: 'aa02',
        New: 'new',
        View: ':id'
    };
    public static readonly AA03: { readonly Base: string; readonly View: string } = {
        Base: 'aa03',
        View: ':id'
    };
    public static readonly SR01: { readonly Complete: string; readonly Base: string; readonly New: string; readonly NewWithSource: string; readonly View: string } = {
        Base: 'sr01',
        New: 'new',
        NewWithSource: 'new/:utm_source/:utm_campaign',
        Complete: 'complete',
        View: ':id'
    };
    public static readonly BSP01: {
        readonly Complete: string;
        readonly Base: string;
        readonly New: string;
        readonly AgreementData: string;
        readonly AgreementDataComplete: string;
        readonly AgreementDataInvalidToken: string;
        readonly View: string;
    } = {
        Base: 'bsp01',
        New: 'new',
        Complete: 'complete',
        AgreementData: 'agreement-data/:tokenId',
        AgreementDataComplete: 'agreement-data-complete',
        AgreementDataInvalidToken: 'agreement-data-invalid-token',
        View: ':id'
    };
    public static readonly CP01: { readonly Counterparty: string; readonly Base: string; readonly New: string; readonly Complete: string, readonly AlreadyRegistered: string, readonly View: string } = {
        Base: 'cp01',
        Counterparty: 'counterparty/:id',
        New: 'new',
        Complete: 'complete',
        AlreadyRegistered: 'already-registered',
        View: ':id'
    };
    public static readonly SR03: { readonly Base: string; readonly New: string; readonly View: string } = {
        Base: 'sr03',
        New: 'new',
        View: ':id'
    };
    public static readonly PR03: { readonly Base: string; readonly New: string; readonly View: string } = {
        Base: 'pr03',
        New: 'new',
        View: ':id'
    };
    public static readonly AA01: {
        readonly Base: string;
        readonly New: string;
        readonly Complete: string;
        readonly AgreementData: string;
        readonly AgreementDataComplete: string;
        readonly AgreementDataInvalidToken: string;
        readonly View: string;
    } = {
        Base: 'aa01',
        New: 'new',
        Complete: 'complete',
        AgreementData: 'agreement-data/:tokenId',
        AgreementDataComplete: 'agreement-data-complete',
        AgreementDataInvalidToken: 'agreement-data-invalid-token',
        View: ':id'
    };
    public static readonly BSP03: { readonly Base: string; readonly View: string } = {
        Base: 'bsp03',
        View: ':id'
    };
    public static readonly RequestsList = {
        Base: 'request-list'
    };
    public static readonly DepartmentTaskList = {
        Base: 'department-task-list'
    };
}
/* eslint-enable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */
